module.exports = __webpack_public_path__ + "static/img/8.0bab0da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/8.png
// module id = Yz6P
// module chunks = 0